import React from "react";
import Table, { TableType } from "components/Table/Table";
import styles from "./Pricing.module.scss";
import Wrapper from "components/commons/wrapper/Wrapper";
import Header from "components/commons/header/Header";
import { strings } from "intl/fa";
import { HelpMessage, Title } from "@bale/ui";

const Pricing = () => {
  return (
    <Wrapper className={styles.wrapper}>
      <Header title={strings.pricing.title} />
      <div className={styles.wrapperBox}>
        <div className={styles.pricing}>
          <div className={styles.data}>
            <Title
              title={strings.pricing.baleLink.title}
              className={styles.title}
            />
            <Table table={strings.pricing.baleLink.table} />
            <div className={styles.help}>
              <HelpMessage message={strings.pricing.baleLink.help} />
            </div>
          </div>

          <div className={styles.data}>
            <Title
              title={strings.pricing.externalLink.title}
              className={styles.title}
            />
            <Table table={strings.pricing.externalLink.table} />
            <div className={styles.help}>
              <HelpMessage message={strings.pricing.externalLink.help} />
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
};

export default Pricing;
